import { createSlice } from "@reduxjs/toolkit";

export const mapSlice = createSlice({
  name: 'maps',
  initialState: {
    isLoaded: false,
  },
  reducers : {
    mapLoaded: (state, {payload}) => {
      state.isLoaded = payload;
    }
  }
})

export const { mapLoaded } = mapSlice.actions